module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_search-92f3608b54b0de4ba20fcf468c0c89d3.svg";